<div class="dynamic-section">
    <div class="dynamic-header">
        <div class="dh-left">
            <span class="s-icon">👨‍👩‍👦</span>
            <h3>Guardians</h3>
        </div>
        <button (click)="add.emit()" class="btn-add" type="button">+ Add Guardian</button>
    </div>

    @for (g of formArray.controls; track $index) {
        <div [formGroup]="asFormGroup(g)" class="item-card">
            <div class="row g-3">
                <div class="col-md-2">
                    <div class="field">
                        <label class="field-label">Relation <span class="req">*</span></label>
                        <select class="f-select" formControlName="relation_id">
                            <option value="">Select</option>
                            @for (item of relations; track item.value) {
                                <option [value]="item.value">{{ item.label }}</option>
                            }
                        </select>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="field">
                        <label class="field-label">First Name <span class="req">*</span></label>
                        <input class="f-input" formControlName="first_name" placeholder="First name">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="field">
                        <label class="field-label">Middle Name</label>
                        <input class="f-input" formControlName="middle_name" placeholder="Middle name">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="field">
                        <label class="field-label">Last Name <span class="req">*</span></label>
                        <input class="f-input" formControlName="last_name" placeholder="Last name">
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="field">
                        <label class="field-label">Mobile <span class="req">*</span></label>
                        <input (input)="numbersOnly.emit($event)"
                               class="f-input"
                               formControlName="mobile"
                               inputmode="numeric"
                               maxlength="10"
                               placeholder="10-digit mobile"
                               type="text">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="field">
                        <label class="field-label">Email <span class="req">*</span></label>
                        <input class="f-input" formControlName="email" placeholder="email@example.com" type="email">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="field">
                        <label class="field-label">Qualification <span class="opt">(Optional)</span></label>
                        <input class="f-input" formControlName="qualification" placeholder="Highest qualification">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="field">
                        <label class="field-label">Occupation <span class="opt">(Optional)</span></label>
                        <input class="f-input" formControlName="occupation" placeholder="Occupation">
                    </div>
                </div>
                @if ($index > 0) {
                    <div class="col-12 d-flex justify-content-end">
                        <button (click)="remove.emit($index)" class="btn-remove" type="button">✕ Remove</button>
                    </div>
                }
            </div>
        </div>
    }
</div>
